if (!customElements.get('product-model')) {
  customElements.define(
    'product-model',
    class ProductModel extends HTMLElement {
      constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        if (poster.querySelector('[data-poster-button]')) {
          poster.querySelector('[data-poster-button]').addEventListener('click', this.loadContent.bind(this));
        }
        
      }
      

      loadContent() {
        
        if (!this.getAttribute('loaded')) {
          window.stopAllSiteVideos();
          this.removePoster();
          const content = document.createElement('div');
          content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

          this.setAttribute('loaded', true);
          const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
          // if (focus) deferredElement.focus();
          deferredElement.focus?.();
        
        }
       
        Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);

        setTimeout(() => {
          const modelViewer = this.querySelector('model-viewer');
          if (modelViewer) {
            modelViewer.addEventListener('click', this.stopOtherVideos.bind(this));
          }
        }, 10);

      }
      stopOtherVideos(){
        window.stopAllSiteVideos();
      }
      removePoster() {
        const posterContainer = this;
        if (posterContainer) {
          posterContainer.style.transition = 'opacity 0.5s ease-in-out';
          const elementsToRemove = [
            posterContainer.querySelector('img'),
            posterContainer.querySelector('[data-poster-button]'),
          ].filter(Boolean);

          elementsToRemove.forEach((element) => {
            element.classList.add('poster-fade-out');
            setTimeout(() => element.remove(), 500);
          });
          posterContainer.querySelector('button').classList.add('hidden');
        }
      }

      /*setupModelViewerUI(errors) {
        if (errors) return;

        this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
      }*/

        setupModelViewerUI(errors) {
          if (errors) return;
        
          const modelViewer = this.querySelector('model-viewer');
          let observer = null;
        
          const tryInit = () => {
            const modelViewer = this.querySelector('model-viewer');
            if (modelViewer) {
              this.modelViewerUI = new Shopify.ModelViewerUI(modelViewer);
              if (observer) observer.disconnect();
            }
          };
        
          tryInit(); // Try immediately in case it's already there
        
          // Set up observer *after* defining it
          observer = new MutationObserver(tryInit);
          observer.observe(this, { childList: true, subtree: true });
        }
        
      
    }
  );
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;
    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});
